<template>
  <div class="user-messsage">
    <h2 class="user-title Medium">我的资料</h2>
    <div class="form">
      <el-form
        v-loading="loading"
        element-loading-text="加载中..."
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        label-position="top"
        class="demo-ruleForm"
      >
        <el-form-item label="会员卡类型" prop="MbrCardType">
          <el-input v-model="ruleForm.MbrCardType" disabled></el-input>
        </el-form-item>
        <el-form-item label="会员卡号" prop="mbrCardNo">
          <el-input v-model="ruleForm.mbrCardNo" disabled></el-input>
        </el-form-item>
        <el-form-item label="会员姓名" prop="memberName">
          <el-input v-model="ruleForm.memberName"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model="ruleForm.mobile" disabled></el-input>
        </el-form-item>
        <el-form-item label="电子邮箱" prop="email">
          <el-input v-model="ruleForm.email"></el-input>
        </el-form-item>
        <el-form-item>
          <div @click="editmemberInfo" class="edit">保存编辑</div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapState,mapGetters,mapMutations} from 'vuex'
import { getmemberInfo,editmemberInfo } from "@/request/member.js";
import {isEmail} from '@/utils/validator'
export default {
  name: "userMessage",
  data() {
    var validateEmail = (rule, value, callback) => {
      if (value!=''&&!isEmail(value)) {
        callback(new Error('请输入正确的邮箱!'));
      } else {
        callback();
      }
    };
    return {
      loading:false,
      ruleForm: {
        memberName: '',
        mbrCardTypeName: '',
        MbrCardType: "",
        mbrCardNo: '',
        mobile: '',
        email: '',
      },
      rules:{
        memberName: [
          { required: true, message: '请输入用户名', trigger: 'change' },
        ],
        email: [
          { validator: validateEmail, trigger: 'change' },
        ],
      }
    };
  },
  computed:{
    ...mapState('member',['GuestCName','MbrCardType','MbrCardNo','Mobile','Email']),
    ...mapGetters('member',['Token','ProfileId']),
  },
  watch:{
    GuestCName(){
      this.updateForm()
    },
    MbrCardTypeName(){
      this.updateForm()
    },
    MbrCardNo(){
      this.updateForm()
    },
    Mobile(){
      this.updateForm()
    },
    Email(){
      this.updateForm()
    },
  },
  methods:{
    ...mapMutations('member', ['updateUserInfo']),
    //获取会员信息
    getmemberInfo(){
      this.loading=true
      getmemberInfo(this.Token,{profileId:this.ProfileId})
      .then(res=>{
        const data=res.response
        this.updateUserInfo(data)
        this.loading=false
      })
      .catch(err=>{
        this.loading=false
      })
    },
    //更新表单
    updateForm(){
      this.ruleForm.memberName=this.GuestCName
      this.ruleForm.MbrCardType=this.MbrCardType
      this.ruleForm.mbrCardNo=this.MbrCardNo
      this.ruleForm.mobile=this.Mobile
      this.ruleForm.email=this.Email
    },
    //修改会员信息
    editmemberInfo(){
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.loading=true
          editmemberInfo({
            memberName:this.ruleForm.memberName,
            email:this.ruleForm.email,
            profileId:this.ProfileId
          })
          .then(res=>{
            this.$message({
              message: res.msg,
              type: 'success'
            });
            this.getmemberInfo()
          })
          .catch(err=>{
            this.loading=false
          })
        } 
      });
    }
  },
  mounted(){
    this.updateForm()
  }
};
</script>

<style scoped>
.form{
    width: 280px;
}
.edit{
    width: 180px;
    height: 40px;
    display: flex;
    background: #2A82E4;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    color: #fff;
    font-weight: 400;
    margin-top: 20px;
    cursor: pointer;
}
</style>